import { ADD_FLASH_MESSAGE, REMOVE_FLASH_MESSAGE } from "../actions";
import { findIndex, propEq } from "ramda";

export const initialState = [];

export type FlashesState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		case ADD_FLASH_MESSAGE: {
			let message = action.message;
			return state.concat(message);
		}

		case REMOVE_FLASH_MESSAGE: {
			const index = findIndex(propEq("id", action.id))(state);

			state.splice(index, 1);

			return [...state];
		}

		default:
			return state;
	}
}
